import React from "react";
import _ from "lodash";
import LoaderIcon from "Components/loader/LoaderIcon";
import ListFilter from "Components/listFilter/ListFilter";
import PropTypes from "prop-types";
import Button from "Components/button/Button";
import ButtonIcon from "Components/buttonIcon/ButtonIcon";
import ETLiveFilters from "Components/etliveFilters/ETLiveFilters";
import ETLiveLog from "Components/etliveLog/ETLiveLog";
import TranslatedString from "Components/TranslatedString";
import t from "Utils/translation";
import { exportCSVFile } from "Utils/csv";
import Select from "Components/select/Select";
import DropdownIndicator from "Components/customArrowSelect/CustomArrowSelect";
import { Icon, notFound, disabledEtlive, selectLogEtlive, refresh } from "Icons/index";
import cx from "classnames";
import s from "./listEtlive.scss";
import QboxmailApi from "@/qboxmailApi";

import qs from "query-string";
const api = new QboxmailApi({ useCookie: true });

const ContextTypes = {
  router: PropTypes.object,
  getLoggedUserType: PropTypes.func,
  getLoggedUser: PropTypes.func,
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
};

class ETLive extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      loggedUserType: context.getLoggedUserType(),
      loggedUser: context.getLoggedUser(),
      etliveNotAvailable: false,

      logs: [],
      areLogsLoading: false,
      paginationInfo: {},
      noMoreData: false,
      isLoadingMore: false,
    };
  }

  UNSAFE_componentWillMount() {
    const {
      location: { query },
    } = this.props;

    const { loggedUserType } = this.state;

    let newQuery = Object.assign({}, query);
    if (loggedUserType === "Postmaster") {
      newQuery = this.setDefaultValuesPostmaster(newQuery);
    }
    if (loggedUserType === "EmailAccount") {
      newQuery = this.setDefaultValuesEmailAccount(newQuery);
    }

    this.updateQuery(newQuery);
    if (newQuery.type && newQuery.domain) {
      this.getLogs({ ...newQuery, with_totals: "yes" });
    }
  }

  componentWillUnmount() {
    // this.props.resetForm();
  }

  setDefaultValuesPostmaster(currentQuery) {
    const loggedUser = this.context.getLoggedUser();
    return Object.assign({}, currentQuery, { domain: loggedUser.domain_code });
  }

  setDefaultValuesEmailAccount(currentQuery) {
    const loggedUser = this.context.getLoggedUser();
    return Object.assign({}, currentQuery, {
      domain: loggedUser.domain_code,
      mailbox: loggedUser.code,
    });
  }

  updateQuery = (newQuery) => {
    const { loggedUserType } = this.state;
    if (loggedUserType === "Postmaster") {
      newQuery = this.setDefaultValuesPostmaster(newQuery);
    }
    if (loggedUserType === "EmailAccount") {
      newQuery = this.setDefaultValuesEmailAccount(newQuery);
    }
    if (newQuery.domain && this.props.location.query.domain !== newQuery.domain) {
      newQuery.mailbox = undefined;
    }

    if (newQuery.domain === null) newQuery.mailbox = null;

    this.props.history.push({
      pathname: this.props.location.pathname,
      search: qs.stringify({
        ...this.props.location.query,
        ...newQuery,
      }),
    });
  };

  UNSAFE_componentWillReceiveProps({ location: { query } }) {
    if (query.type && query.domain && !_.isEqual(query, this.props.location.query)) {
      this.getLogs({ ...query, with_totals: "yes" });
    }

    if (!query.type && this.props.location.query.type) {
      this.resetLogs();
    }
  }

  refreshLogs = () => {
    this.getLogs({ ...this.props.location.query, with_totals: "yes" });
  };

  resetLogs = () => {
    this.setState({
      logs: [],
      paginationInfo: {},
    });
  };

  exportListAsCSV = () => {
    const {
      location: { query },
    } = this.props;

    const { logs } = this.state;
    let censoredLogs = _.map(logs, (log) =>
      _.omit(log, ["_id", "uid", "mid", "filter_action", "filter_detail", "filter", "logout_error", "encryption"])
    );
    let headers = Object.keys(censoredLogs[0]);

    const index = headers.indexOf("sid");

    if (index !== -1) {
      headers[index] = "session";
    }

    var fileTitle = `${query.type} export`;

    exportCSVFile(headers, censoredLogs, fileTitle);
  };

  getTabsForType(type) {
    if (type === "mailins") {
      return ["all", "accept", "spam-mark", "reject"];
    } else if (type === "mailouts") {
      return ["all", "accepted", "rejected", "authfailed"];
    } else if (type === "accesses") {
      return ["all", "success", "login-error"];
    }
  }

  loadMore = () => {
    this.getLogs({
      ...this.props.location.query,
      since: this.state.paginationInfo.last,
      appending: true,
    });
  };

  getLogs = async (opts) => {
    this.setState({
      isLoadingMore: opts.appending,
      areLogsLoading: !opts.appending,
    });

    let request;
    if (opts.type === "accesses") request = "getAccesses";
    if (opts.type === "mailins") request = "getMailins";
    if (opts.type === "mailouts") request = "getMailouts";

    let resp;
    try {
      resp = await api[request](opts);
    } catch ({ status }) {
      if (status === 404) {
        let newState = { etliveNotAvailable: false, noMoreData: true, paginationInfo: {} };

        if (!opts.appending) newState.logs = [];

        this.setState(newState);
      } else if (status === 500) {
        this.setState({ etliveNotAvailable: true });
      } else {
        this.setState({ etliveNotAvailable: false });
      }

      this.setState({ areLogsLoading: false });
      return;
    }

    let noMoreData = false;
    if (resp.resources.length === 0 || resp.resources.length < resp.pagination.count) {
      noMoreData = true;
    }

    let logs, pagination;
    if (opts.appending) {
      logs = this.state.logs;
      pagination = this.state.paginationInfo;
    } else {
      logs = [];
      pagination = {};
    }

    this.setState({
      logs: logs.concat(resp.resources),
      areLogsLoading: false,
      paginationInfo: {
        ...pagination,
        ...resp.pagination,
      },
      etliveNotAvailable: false,
      isLoadingMore: false,
      noMoreData,
    });
  };

  render() {
    const {
      location,
      location: { query },
    } = this.props;

    const { logs, areLogsLoading, noMoreData, isLoadingMore, paginationInfo } = this.state;
    const { isMobileDevice, isMediaMobile, isLoggedUserAdmin } = this.context;

    return (
      <div className={cx(s.listEtlive, { [s.isMobileDevice]: isMobileDevice() })}>
        <div className={s.headerList}>
          <div className={cx("sectionTitle", s.titleList)}>{t("etlive.list.header.title")}</div>

          {!isMediaMobile() && (
            <div className={cx("sectionDesc", s.descList)}>
              <TranslatedString>etlive.list.header.dsc</TranslatedString>
            </div>
          )}

          <div className={s.actionsList}>
            <Button docsKey="etlive" color="docs" className={s.btnList} onlyIcon={isMediaMobile()}>
              button.docs
            </Button>
          </div>
        </div>

        <div className={s.contentList}>
          <ETLiveFilters
            className={s.etliveFilters}
            currentQuery={query}
            updateQuery={this.updateQuery}
            loggedUserType={this.state.loggedUserType}
            loggedUser={this.state.loggedUser}
          />

          <div className={s.filters}>
            <ListFilter
              className={s.statusFilter}
              values={query.type ? this.getTabsForType(query.type) : []}
              active={query.action}
              location={location}
              paginationInfo={query}
              param="action"
              url={location.pathname}
              disabled={!query.type}
            />

            <ButtonIcon
              className={cx(s.iconRefresh, { ["isRefreshing"]: areLogsLoading })}
              icon={refresh}
              onClick={this.refreshLogs}
            />

            {!isMediaMobile() && (
              <div className={s.numbeResults}>
                <div className={s.labelNumbeResults}>{t("detailInfo.label.search.results")}</div>

                {(paginationInfo.total_records || paginationInfo.total_records === 0) && (
                  <div className={s.dataNumbeResults}>{paginationInfo.total_records}</div>
                )}
              </div>
            )}

            {!isMediaMobile() && (
              <Select
                className={s.pageShow}
                components={{ DropdownIndicator }}
                name="count"
                onChange={this.updateQuery}
                value={query.count ? parseInt(query.count) : 25}
                noLabel
                options={[
                  { label: 25, value: 25 },
                  { label: 50, value: 50 },
                  { label: 100, value: 100 },
                ]}
              />
            )}

            {!isMobileDevice() && !isMediaMobile() && (
              <Button className={s.btnExport} onClick={this.exportListAsCSV} disabled={!(logs.length > 0)}>
                button.exportCSV
              </Button>
            )}
          </div>

          <div className={s.table}>
            {!query.type && (
              <div className={s.wrapIllustration}>
                <Icon svg={selectLogEtlive} width="10rem" height="10rem" />
                <div className={s.msgIllustration}>{t("etlive.list.searchMsg.selectLog")}</div>
              </div>
            )}
            {query.type && !query.domain && (
              <div className={s.wrapIllustration}>
                <Icon svg={selectLogEtlive} width="10rem" height="10rem" />
                <div className={s.msgIllustration}>{t("etlive.list.searchMsg.selectDomain")}</div>
              </div>
            )}
            {!areLogsLoading &&
              logs.length > 0 &&
              query.type &&
              query.domain &&
              !this.state.etliveNotAvailable &&
              logs.map((log) => (
                <ETLiveLog
                  log={log}
                  domainCode={query.domain}
                  type={query.type}
                  key={log.uid}
                  loggedUserType={this.state.loggedUserType}
                />
              ))}

            {this.state.etliveNotAvailable && (
              <div className={s.wrapIllustration}>
                <Icon svg={disabledEtlive} width="10rem" height="10rem" />
                <div className={s.msgIllustration}>{t("infoMsg.etliveUnavailable.msg")}</div>
              </div>
            )}

            {logs.length === 0 && query.type && query.domain && !this.state.etliveNotAvailable && (
              <div className={s.wrapIllustration}>
                <Icon svg={notFound} width="10rem" height="10rem" />
                <div className={s.msgIllustration}>{t("infoMsg.noRecords.msg")}</div>
                <div className={s.descIllustration}>{t("infoMsg.noRecords.desc")}</div>
              </div>
            )}
            {logs.length > 0 && query.type && query.domain && !areLogsLoading && !noMoreData && (
              <div className={s.wrapLoadMore}>
                {isLoadingMore && <LoaderIcon iconSize="2rem" />}

                {!isLoadingMore && (
                  <div className="internalLink" onClick={this.loadMore}>
                    {t("button.loadMore")}
                  </div>
                )}
              </div>
            )}
            {noMoreData && logs.length > 0 && !areLogsLoading && (
              <div className={s.wrapLoadMore}>
                <TranslatedString>infoMsg.noMoreLogs</TranslatedString>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

ETLive.contextTypes = ContextTypes;

export default ETLive;
